module.exports = __webpack_public_path__ + "static/media/reutersColor.08f77495.svg";